import list_icon from '@/assets/img/device/mer68/Mer68SE_icon.png'
import { Mer68Lite } from './mer68lite'

export class Mer68SE extends Mer68Lite {
  name: string = 'Mer68_SE'
  icon: string = list_icon
  width: number = 672
}
